import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import api from "../../api";
import { toast } from "react-toastify";

export default function CommissionsTab({ raw, onSaved }) {
  const { t } = useTranslation();
  const [rate, setRate] = useState(raw.commission_rate ?? "0");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    const n = parseFloat(rate);
    if (isNaN(n) || n < 0 || n > 100) {
      toast.error(t("settings.commissions.rangeError"));
      return;
    }
    setSaving(true);
    try {
      await api.put("/settings", { commission_rate: String(n) });
      toast.success(t("settings.commissions.saved"));
      onSaved?.();
    } catch {
      toast.error(t("settings.common.saveError"));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-6 max-w-lg">
      <div className="bg-base-200/50 border border-base-200 rounded-xl p-4 text-sm text-base-content/70">
        {t("settings.commissions.intro")}
      </div>

      <div className="flex flex-col gap-1">
        <label className="text-sm font-semibold text-base-content/70">
          {t("settings.commissions.rateLabel")}
        </label>
        <div className="flex items-center gap-2">
          <input
            type="number"
            min="0"
            max="100"
            step="0.1"
            value={rate}
            onChange={(e) => setRate(e.target.value)}
            className="input input-bordered bg-base-200 border-base-300 focus:border-primary focus:outline-none w-40"
          />
          <span className="text-base-content/60 font-semibold">%</span>
        </div>
        <p className="text-xs text-base-content/40 mt-1">
          {t("settings.commissions.example")}
        </p>
      </div>

      <button
        onClick={save}
        disabled={saving}
        className="btn btn-primary"
      >
        {saving ? t("settings.common.saving") : t("settings.common.save")}
      </button>
    </div>
  );
}
